import { FormControl, FormLabel } from "@mui/material";
import { Controller } from "react-hook-form";
import { MuiTelInput, MuiTelInputInfo } from "mui-tel-input";

type AGPhoneInputProps = {
  label: string;
  required?: boolean;
  name: string;
  onChangeInput?: (value: string, info: MuiTelInputInfo) => void;
  value?: string;
  size?: "medium" | "small";
  error?: string;
  control: any; // Form control object from React Hook Form
  minLength?: number;
  maxLength?: number;
  onBlur?: () => void;
};

const AGPhoneInput: React.FC<AGPhoneInputProps> = ({
  label,
  name,
  required = false,
  size = "small",
  value,
  onChangeInput,
  error,
  control,
  minLength,
  maxLength,
  onBlur,
}) => {
  return (
    <FormControl error={!!error} fullWidth margin="normal">
      <FormLabel className=" mb-1 font-semibold text-black text-sm">
        {label} {required ? "*" : ""}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={value ?? ""}
        render={({ field }) => (
          <MuiTelInput
            error={!!error}
            helperText={error || ""}
            required={required}
            forceCallingCode
            onlyCountries={["SL"]}
            defaultCountry={"SL"}
            className="w-full"
            size={size}
            onBlur={onBlur}
            value={field.value}
            onChange={(val: string, info: MuiTelInputInfo) => {
              field.onChange(val);
              if (onChangeInput) onChangeInput(val, info);
            }}
            name={name}
          />
        )}
        rules={
          required
            ? {
                minLength: {
                  value: 6,
                  message: `Minimum length is 6 digits`,
                },
                maxLength: {
                  value: 20,
                  message: `Minimum length is 20 digits`,
                },
                validate: (value: string) => {
                  if (!value || value.trim() === "") {
                    return "Phone number cannot be empty";
                  }
                  if (value.trim().length < 6) {
                    return "Phone number must be at least 6 characters";
                  }
                  return true;
                },
              }
            : {}
        }
      />
    </FormControl>
  );
};

export default AGPhoneInput;
